export * from './defaultTranslations';

export const APP_NAME = 'basket-bubble';

export const EMOTION_CACHE_KEY = `${APP_NAME}-emotion-cache-key`;

export const IDENTITY_CLIENT_ID = 'SPADev';

// Bubble settings
export const bubbleDuration = 2000;
export const bubbleHeight = 94;
